import Events from '@/api/services/objects/events'
import Vue from 'vue'
import i18n from '@/localization'
const getDefaultState = () => ({
  events: {rows: [], records: 0}
})

export default {
  state: getDefaultState(),
  getters: {
    getEvents: (state) => (type) => (type ? state.events.rows.filter(item => item.type.toLowerCase().includes(type.toLowerCase())) : state.events.rows),
    getFilteredEvents: (state) => (type, search, keys) => {
      const result = type ? state.events.rows.filter(item => item.type.toLowerCase().includes(type.toLowerCase())) : state.events.rows
      if (!search.length) {
        return result
      }
      const lowSearch = search.map(item => item.toString().toLowerCase().trim())
      if (keys) {
        return result.filter(item =>
          lowSearch.filter(obj => (Array.isArray(keys) ? keys : [String(keys)]).some(key => String(key === 'date' ? Vue.moment(item[key]).format(i18n.t('short_date_format')) : item[key]).toLowerCase().includes(obj))).length === lowSearch.length
        )
      }
      return result.filter(item => lowSearch.filter(obj => Object.values(item).some(val => String(val).toLowerCase().includes(obj))).length === lowSearch.length)
    }
  },
  mutations: {
    updateEvents (state, data) {
      if (!Array.isArray(data.rows)) {
        data.rows = [].concat(data.rows)
      }
      state.events = data
    },
    resetEventsState (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    getObjectsEvents ({commit, state}, params) {
      if (!state.events.records) {
        return new Promise(resolve => {
          Events.getAllEvents(params).then(data => {
            commit('updateEvents', data)
            resolve(data)
          })
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/events.js